/**
 * Alcedis advanced list filter
 * @copyright   Alcedis GmbH
 * @version     SVN: $Id: listfilter.js 18718 2013-03-21 15:07:59Z dwi $
 * @author Dirk Aevermann <dae@alcedis.de>
 */

/** some array functions that are not defined in IE
    not implemented as Array.prototype because this would break IE arrays!
*/

/**
 * substitute for Array.every
 */
arrayEvery = function(arr, fun) {
    var len = arr.length;
    if (typeof fun != "function") {
        throw new TypeError();
    }
    var thisp = arguments[2];
    for ( var i = 0; i < len; i++) {
        if (i in arr && !fun.call(thisp, arr[i])) {
            return false;
        }
    }

    return true;
};

/**
 * substitute for Array.forEach
 */
arrayForEach = function(arr, fun /* , thisp */) {
    var len = arr.length;
    if (typeof fun != "function") {
        throw new TypeError();
    }
    var thisp = arguments[2];
    for ( var i = 0; i < len; i++) {
        if (i in arr) {
            fun.call(thisp, arr[i]);
        }
    }
};

/**
 * substitute for Array.some
 */
arraySome = function(arr, fun /* , thisp */) {
    var len = arr.length;
    if (typeof fun != "function") {
        throw new TypeError();
    }
    var thisp = arguments[2];
    for ( var i = 0; i < len; i++) {
        if (i in arr && fun.call(thisp, arr[i])) {
            return true;
        }
    }
    return false;
};

/**
 * substitute for Array.map
 */
arrayMap = function(arr, fun /* , thisp */) {
    var len = arr.length;
    if (typeof fun != "function") {
        throw new TypeError();
    }
    var res = new Array(len);
    var thisp = arguments[2];
    for ( var i = 0; i < len; i++) {
        if (i in arr) {
            res[i] = fun.call(thisp, arr[i]);
        }
    }
    return res;
};

/**
 * stringMatcher matches a given string
 *
 * @param stringToMatch
 * @returns object
 */
var stringMatcher = function(stringToMatch) {
    this.str = stringToMatch.toLowerCase();

    /**
     * checks if Text matches this.str
     * @return bool
     */
    this.match = function (text) {
        return text.toLowerCase().indexOf(this.str) !== -1;
    };

    /**
     * for a given array of bool aggregates the result
     * @return bool true if at least one (column) is true
     */
    this.aggregate = function(values) {
        return arraySome(values, function(val){return val === true;});
    };
};


/**
 * negativeStringMatcher negative matches a given string
 *
 * @param stringToMatch
 * @returns object
 */
var negativeStringMatcher = function(stringToMatch) {
    this.str = stringToMatch.toLowerCase();

    /**
     * checks if Text not contains this.str
     * @return bool
     */
    this.match = function (text) {
        return text.toLowerCase().indexOf(this.str) === -1;
    };

    /**
     * for a given array of bool aggregates the result
     * @return bool true if all elements (columns) are true
     */
    this.aggregate = function(values) {
        return arrayEvery(values, function(val){return val === true;});
    };
};

/**
 * orMatcher matcher container that matches against contained matchers and or's the results
 *
 * @param stringToMatch
 * @returns object
 */
var orMatcher = function() {
    this.isOr = true;
    this.matchers = new Array();

    /**
     * add a matcher to the matcher list
     */
    this.addMatcher = function (matcher) {
        this.matchers.push(matcher);
    };

    /**
     * matches contained matchers agaunst text
     * @return array of boolean, one entry per contained matcher
     */
    this.match = function (text) {
        if (this.matchers.length === 0) {
            return true;
        }
        return arrayMap(this.matchers, function (matcher) {
            return matcher.match(text);
        });
    };

    /**
     * helper that takes a 2d array and flips rows and columns
     * [[1,a],[2,b],[3,c]] will become [[1,2,3],[a,b,c]]
     */
    this.transposeArray = function (odata) {
        var data = odata.slice();
        var rows = data.length;
        if(rows == 0) {
            return new Array();
        }
        var cols = data[0].length;
        var arrays = arrayMap(data[0], function(ignore){return new Array();});
        for (var i = 0; i < rows; i++){
            for (var j = 0; j < cols; j++){
                arrays[j][i] = data[i][j];
            }
        }
        return arrays;
    };

    /**
     * aggregates the results of the matchers
     * return bool true if atleast one contained matcher aggregates to true
     */
    this.aggregate = function(values) {
        // reorganize results so that the matchers can aggregate
        // input is array with one array per column with results of contained matchers
        // needed is an array with one array per matcher with results for columns
        var transposed = this.transposeArray(values);
        var mcount = transposed.length;
        var aggregated = new Array();
        for (var n = 0; n < mcount; n++){
            aggregated.push(this.matchers[n].aggregate(transposed[n]));
        }
        return arraySome(aggregated, function(val){return val;});
    };
};


/**
 * filter object that implements advanced search technique
 */
var advancedListFilter = (function() {
    /**
     * reqular expression to split query
     * result elements are
     * $1 = OR
     * $2 = -
     * $3 = quoted string ("")
     * $4 = unquoted string
     */
    var regexp = /\s(OR)[\s]|(-?)(?:"([^"]*)"|(\S+))/ig;

    /**
     * matchers contains the actual parsed matcher, if any
     */
    var matchers = [];

    /**
     * splits the query and gives array with search strings
     * @param query
     * @returns array of strings
     */
    this.getHighlights = function(query) {
        resultArray = new Array();
        while(result = regexp.exec(query)) {
            var search = result[3] || result[4];
            if (result[2] !== '-' && search != '' && search !== undefined) {
                resultArray.push(search);
            }
        }
        return resultArray;
    };

    /**
     * parses the query and prepares internal matcher structure
     * @param query
     * @returns void
     */
    this.parseQuery = function(query) {
        var useOr = false;
        matchers = new Array();
        while(result = regexp.exec(query)) {
            var search = result[3] || result[4];
            if (result[1] !== undefined && result[1] != '') {
                // search for 'or' when at first position
                if(matchers.length == 0) {
                    this.addMatcher(new stringMatcher(result[1]));
                } else {
                    this.addMatcher(new orMatcher())
                }
            } else if (result[2] === '-') {
                this.addMatcher(new negativeStringMatcher(search));
            } else {
                this.addMatcher(new stringMatcher(search));
            }
        }
    };


    /**
     * check whether there are parsed matchers or not
     * @returns boolean true if no matchers are parsed
     */
    this.isEmpty = function() {
        return matchers.length == 0;
    };

    /**
     * adds a matcher
     * @param matcher
     * @returns void
     */
    this.addMatcher = function(matcher) {
        if (matchers.length == 0) {
            matchers.push(matcher);
        } else {
            var lastmatcher = matchers.pop();
            if (this.useOr === true) {
                // ignore consecutive or's
                if (matcher.isOr !== true) {
                    lastmatcher.addMatcher(matcher);
                }
            } else {
                if (matcher.isOr === true) {
                    matcher.addMatcher(lastmatcher);
                    lastmatcher = matcher;
                } else {
                    matchers.push(lastmatcher);
                    lastmatcher = matcher;
                }
            }
            matchers.push(lastmatcher);
        }
        // remember to use 'or'
        this.useOr = matcher.isOr === true;
    };


    /**
     * checks an array agains contained matchers
     * @param row
     * @returns bool true if all matchers are happy
     */
    this.matchRow = function(row) {
        var match = arrayMap(matchers, function(matcher) {
            var rowmatch = arrayMap(row, function(col){
                return matcher.match(col);
            });
            var rowagg = matcher.aggregate(rowmatch);
            return rowagg;
        });
        return arrayEvery(match, function(val){return val === true;});
    };

    return this;
})();

